import { Injectable, OnDestroy } from '@angular/core';
import { AjaxService } from '.././services/ajax.service';
import { EmitterService } from '../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Injectable()
export class SessionLimitService implements OnDestroy {
  sessionLimitResponse = null;
  sessionLimitCallStack=[];
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private ajaxService: AjaxService,
    private emitterService: EmitterService,
  ) {
    this.emitterService.logoutComplete$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.sessionLimitResponse = null;
      this.sessionLimitCallStack=[];
    });

    this.emitterService.getSessionLimitFlag$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.sessionLimitResponse=null;
      this.sessionLimitCallStack = [];
    });
  }

  getSessionLimit(): Promise<String>{
    if (this.sessionLimitResponse){
        return this.sessionLimitResponse;
    }else{
      return new Promise((resolve,reject)=>{
        if(this.sessionLimitCallStack.length > 0){
          this.sessionLimitCallStack.push(resolve);
        }
        else{
          this.sessionLimitCallStack.push(resolve);
          Promise.resolve(this.ajaxService.getSessionLimit()).then(sessionLimitData => {
            if(sessionLimitData){
              this.sessionLimitResponse = sessionLimitData;
              for(let call in this.sessionLimitCallStack){
                this.sessionLimitCallStack[call](this.sessionLimitResponse);
              }
              this.sessionLimitCallStack=[];
            }
          });
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
